import React from "react";
import StatusDropDown from "../StatusDropDown";
import { Flex } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import Constants from "../../../constants/text-constants";
import ReadOnlyTextField from "../ReadOnlyTextField";
import { useMst } from "../../../hooks/useMst";
import Timer from "../../atoms/Timer";

const StatusContainer = observer((props) => {
  const {
    statusDropdownItems,
    currentStatusCode,
    currentReasonCode,
    onChange,
    currentStateChangeTime,
  } = props;

  let { permissionStore, currentUser } = useMst();

  // if we have correct permissions show dropdown otherwise show the readonly view
  let hasPermissions =
    permissionStore.havePermissions("Call Manager", [
      "PutStatus",
      "PutReason",
    ]) && permissionStore.havePermissions("Reason Codes", ["GetAll"]);

  let displayText = "";
  if(currentUser && currentUser.agent) {
    displayText = currentUser.agent.getStatusDisplayText();
  }

  const statusComponent = hasPermissions ? (
    <StatusDropDown
      items={statusDropdownItems}
      currentStatusCode={currentStatusCode}
      currentReasonCode={currentReasonCode}
      onChange={onChange}
    />
  ) : (
    <ReadOnlyTextField
      label={Constants.STATUS_TITLE}
      text={displayText}
      testId={"myStatusReadOnly"}
    />
  );

  return (
    <Flex column data-testid="statusContainer" gap="gap.smaller">
      {statusComponent}
      <Flex data-testid="statusTimerContainer">
        <Timer
          startTime={currentStateChangeTime}
          testId="statusTimer"
          size="small"
          timestamp
        />
      </Flex>
    </Flex>
  );
});

StatusContainer.propTypes = {
  statusDropdownItems: PropTypes.array,
  currentStatusCode: PropTypes.object,
  currentReasonCode: PropTypes.object,
  onChange: PropTypes.func,
  currentStateChangeTime: PropTypes.string,
};

StatusContainer.defaultProps = {
  statusDropdownItems: [],
};

export default StatusContainer;

